<template>
  <div class="unauthorized-container">
    <h1>Unauthorized</h1>
    <p>You do not have access to this page.</p>
    <router-link to="/">Go to Home</router-link>
  </div>
</template>

<script>
export default {
  name: "Unauthorized",
};
</script>

<style scoped>
.unauthorized-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  text-align: center;
  background-color: #f8f9fa;
}

h1 {
  font-size: 2.5em;
  margin-bottom: 20px;
}

p {
  font-size: 1.2em;
  margin-bottom: 20px;
}

a {
  color: #007bff;
  text-decoration: none;
  font-size: 1.2em;
}

a:hover {
  text-decoration: underline;
}
</style>
